import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';

class MemoryStorage implements Storage {
  private store = new Map<string, string>();

  get length(): number {
    return this.store.size;
  }

  clear(): void {
    this.store.clear();
  }

  getItem(key: string): string | null {
    return this.store.get(key) ?? null;
  }

  key(index: number): string | null {
    return Array.from(this.store.keys())[index] ?? null;
  }

  removeItem(key: string): void {
    this.store.delete(key);
  }

  setItem(key: string, value: string): void {
    this.store.set(key, value);
  }
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService implements Storage {
  private storage: Storage;

  constructor(private env: EnvironmentService) {
    this.storage = this.initStorage();
  }

  private initStorage(): Storage {
    if (this.env.isBrowser()) {
      try {
        const testKey = '__test';
        localStorage.setItem(testKey, '1');
        localStorage.removeItem(testKey);
        return localStorage;
      } catch {
        // localStorage not available or blocked
      }
    }
    return new MemoryStorage();
  }

  get length(): number {
    return this.storage.length;
  }

  clear(): void {
    this.storage.clear();
  }

  getItem(key: string): string | null {
    return this.storage.getItem(key);
  }

  key(index: number): string | null {
    return this.storage.key(index);
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  setItem(key: string, value: string): void {
    try {
      this.storage.setItem(key, value);
    } catch (err) {
      console.warn('setItem failed:', err);
    }
  }

  getItemJson<T = any>(key: string): T | null {
    const raw = this.getItem(key);
    return raw ? JSON.parse(raw) : null;
  }

  setItemJson(key: string, value: any): void {
    this.setItem(key, JSON.stringify(value));
  }
}
